export type ParamValueItemBody = {
  id: string;
  visible: boolean;
};
